import { render, staticRenderFns } from "./CommentsChat.vue?vue&type=template&id=58a5e3c0&scoped=true"
import script from "./CommentsChat.vue?vue&type=script&lang=js"
export * from "./CommentsChat.vue?vue&type=script&lang=js"
import style0 from "./CommentsChat.vue?vue&type=style&index=0&id=58a5e3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5e3c0",
  null
  
)

export default component.exports